/*
*###############################################################################
*Module Name                   : PaymentModeController.js                      #
*Purpose of the Module         : Perform Api calls                             #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 29th 2021, 8:55:38 pm          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

const getPaymentModeByHedCode = async (code) => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = [];
    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };
    await fetch(`${ApiURL}paymode/single/${code}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            data = result.data;
        })
        .catch(error => console.log('error', error));
    return data;
}

const getPaymentModeDetailByDetCode = async (code) => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = [];
    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };
    await fetch(`${ApiURL}paymode/details/search/${code}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            data = result.data;
        })
        .catch(error => console.log('error', error));
    return data;
}



const getPaymentModes = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = [];
    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };
    await fetch(`${ApiURL}paymode`, requestOptions)
        .then(response => response.json())
        .then(result => {
            //console.log(result)
            data = result.data;
        })
        .catch(error => console.log('error', error));
    return data;
}

const getPaymentModeDets = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = [];
    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };
    await fetch(`${ApiURL}paymode/details`, requestOptions)
        .then(response => response.json())
        .then(result => {
            //console.log(result)
            data = result.data;
        })
        .catch(error => console.log('error', error));
    return data;
}

const setPaymentModes = async (PhCode, PhDesc, PhStatus, PhDetail, PhOverPay, PhLinkLoyalty, PhLinkCredit, PhLinkGv, PhLinkPromo, PhRefundMode, PhPointsPer, PhDefault, PhOrder, PhMaxLimit, PhApiSP, PhSWSignOff, PayDet, addNew, menuCode, LogCompanyCode, LocationCode, LogUserType, Reason, blPayHedLinkMyPay, blPayHedLinkWithOverPay) => {
    var myHeaders = new Headers();
    const authToken = localStorage.getItem("authToken")
    myHeaders.append('Authorization', `Bearer ${authToken}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
        "pH_CODE": PhCode,
        "pH_DESC": PhDesc,
        "pH_STATUS": PhStatus,
        "pH_DETAILS": PhDetail,
        "pH_OVERPAY": PhOverPay,
        "pH_LINKLOYALTY": PhLinkLoyalty,
        "pH_LINKCREDIT": PhLinkCredit,
        "pH_LINKGV": PhLinkGv,
        "pH_LINKPROMO": PhLinkPromo,
        "pH_REFUNDMODE": PhRefundMode,
        "pH_POINTSPER": parseInt(PhPointsPer),
        "pH_DEFAULT": PhDefault,
        "pH_ORDER": parseInt(PhOrder),
        "pH_MAXLIMIT": parseFloat(PhMaxLimit),
        "pH_APISP": PhApiSP,
        "pH_SW_SIGNOFF": PhSWSignOff,
        // "PH_LINKMYPAY": blPayHedLinkMyPay,
        // "PH_LINKWITHOVERPAY":blPayHedLinkWithOverPay,
        "m_TBLPAYMODEDET": PhDetail ? PayDet : [],
        "strMenuCode": menuCode,
        "strLoggedCompany": LogCompanyCode,
        "strLoggedLocation": LocationCode,
        "strReason": Reason,
        "strCreateBy": LogUserType,
        "blAddNew": addNew
    });
    console.log(raw)
    const ApiURL = window.Links.ApiURL
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };
    var data = [];
    await fetch(`${ApiURL}paymode`, requestOptions)
        .then(response => data = response)
        .catch(error => console.log('error', error))
    return data;
}

export {
    getPaymentModes,
    getPaymentModeByHedCode,
    setPaymentModes,
    getPaymentModeDets,
    getPaymentModeDetailByDetCode
}

